(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/containers/use-custom-events.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/containers/use-custom-events.js');
"use strict";

const _React = React,
  useEffect = _React.useEffect;
const useCustomEvents = _ref => {
  let appTimeline = _ref.appTimeline,
    ticketInfo = _ref.ticketInfo,
    demo = _ref.isDemo,
    history = _ref.history,
    hasUnscratchedTicket = _ref.hasUnscratchedTicket,
    dispatch = _ref.dispatch;
  const handleBetDone = _ref2 => {
    let detail = _ref2.detail;
    const data = detail.data,
      betAmount = detail.betAmount,
      serviceName = detail.serviceName;
    const ticketPrice = betAmount.value / 100;
    if (!demo) {
      var _svs$ticketgames$tick;
      dispatch({
        type: 'SET_BET_ID',
        payload: data.id
      });
      (_svs$ticketgames$tick = svs.ticketgames.ticketUtility.utils.tracking.gameSpecificTracking[ticketInfo.type]) === null || _svs$ticketgames$tick === void 0 || _svs$ticketgames$tick.bet();
      svs.ticketgames.ticketUtility.utils.tracking.sendAnalytics(data.id, serviceName, ticketPrice, ticketInfo, false);
    }
  };
  const onPlayAgain = () => {
    if (hasUnscratchedTicket) {
      svs.tickets.play.utils.utils.redirectToOngoing();
    } else {
      var _appTimeline$pause, _appTimeline$seek;
      svs.ticketgames.ticketUtility.utils.tracking.trackChooseNewTicket(ticketInfo.type);
      appTimeline === null || appTimeline === void 0 || (_appTimeline$pause = appTimeline.pause) === null || _appTimeline$pause === void 0 || _appTimeline$pause.call(appTimeline);
      appTimeline === null || appTimeline === void 0 || (_appTimeline$seek = appTimeline.seek) === null || _appTimeline$seek === void 0 || _appTimeline$seek.call(appTimeline, 'gameReady');
      history.push("/valja/".concat(ticketInfo.type));
    }
  };
  useEffect(() => {
    const customEvents = [{
      eventName: 'HAS_BET',
      handler: handleBetDone
    }, {
      eventName: 'GAME_LOADING',
      handler: () => {
        svs.tickets.play.utils.utils.hideHeaders(true);
        svs.tickets.play.utils.utils.scrollTopContent();
      }
    }, {
      eventName: 'HAS_CLAIMED',
      handler: () => {
        svs.tickets.play.utils.utils.scrollTopContent();
        svs.tickets.play.utils.utils.showHeaders(true);
      }
    }, {
      eventName: 'REPLAY_FINISHED',
      handler: () => {
        svs.tickets.play.utils.utils.scrollTopContent();
        svs.tickets.play.utils.utils.showHeaders(true);
      }
    }, {
      eventName: 'VIBRATE',
      handler: function () {
        let _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          detail = _ref3.detail;
        const pattern = detail === null || detail === void 0 ? void 0 : detail.pattern;
        if (pattern) {
          svs.tur.device.services.haptics.trigger(pattern);
        }
      }
    }, {
      eventName: 'START_DEVICE_MOTION',
      handler: () => {
        svs.tur.device.services.orientation.start();
      }
    }, {
      eventName: 'STOP_DEVICE_MOTION',
      handler: () => {
        svs.tur.device.services.orientation.stop();
      }
    }];
    const unsubscribeOrientationData = svs.tur.device.services.orientation.onData(data => {
      var _gameloaderHelper$ins;
      const motionData = {
        attitude: {
          roll: data.roll,
          pitch: data.pitch,
          yaw: data.yaw
        }
      };
      (_gameloaderHelper$ins = gameloaderHelper.instance) === null || _gameloaderHelper$ins === void 0 || (_gameloaderHelper$ins = _gameloaderHelper$ins.notifierProxy) === null || _gameloaderHelper$ins === void 0 || _gameloaderHelper$ins.sendNotification('updateDeviceMotionData', motionData);
    });

    customEvents.forEach(evt => addEventListener(evt.eventName, evt.handler));
    return () => {
      customEvents.forEach(evt => removeEventListener(evt.eventName, evt.handler));
      unsubscribeOrientationData();
    };
  }, []);
  return {
    onPlayAgain
  };
};
setGlobal('svs.tickets.play.containers.useCustomEvents', useCustomEvents);

 })(window);